import { render, staticRenderFns } from "./edit-opinion-dialog.vue?vue&type=template&id=66effa1a&scoped=true&"
import script from "./edit-opinion-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-opinion-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-opinion-dialog.vue?vue&type=style&index=0&id=66effa1a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66effa1a",
  null
  
)

export default component.exports